import { useForm } from "react-hook-form";
import { useState, useEffect, useRef } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  ObtenerTiposPeriodos,
  ActualizarTipoPeriodo,
  EliminarTipoPeriodo,
  InsertarTipoPeriodo,
} from "../../redux/periodosSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import Required from "../../Components/Required";
import useSubmit from "../../Hooks/useSubmit";
import { OrderTable } from "../../Components/OrderTable";

const columns = [
  { label: "Código", accessor: "periodoTipoId", sortable: true },
  { label: "Nombre", accessor: "periodoTipoNombre", sortable: true },
  { label: "Acción", accessor: "action", sortable: false },
];


function TiposPeriodos(props) {
  const [showModal, setShowModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("Agregar");
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const { width } = WindowDimension();

  const dispatch = useDispatch();
  const { submitAction } = useSubmit();

  let busqueda = useRef();

  const { tiposPeriodos } = useSelector((state) => state.periodos);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const showModalEdit = (item) => {
    reset(item);
    setTituloModal("Editar");
    setShowModal(true);
  };

  const closeModalEdit = () => {
    reset({
      periodoTipoId: undefined,
      periodoTipoNombre: "",
      estadoId: undefined,
    });
    setShowModal(false);
  };

  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const cargarTiposPeriodos = () => {
    dispatch(ObtenerTiposPeriodos());
  };

  const cargarBusqueda = () => {
    dispatch(ObtenerTiposPeriodos(busqueda.current.value));
  };

  const eliminar = async () => {
    submitAction(EliminarTipoPeriodo, itemSelected, () => {
      closeRemoveModalEdit();
      cargarTiposPeriodos();
    });
  };

  const onSubmit = async (data) => {
    submitAction(
      data.periodoTipoId > 0 ? ActualizarTipoPeriodo : InsertarTipoPeriodo,
      data,
      () => {
        closeModalEdit();
        cargarTiposPeriodos();
      }
    );
  };

  useEffect(() => {
    cargarTiposPeriodos();
  }, [dispatch]);

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <div className="header-admin-bar-items">
          <button
            className="main-admin-button"
            onClick={() => {
              setShowModal(true);
              setTituloModal("Agregar");
              setValue("tipo", "");
              reset();
            }}
          >
            +
          </button>
          <h2>Tipos de periodos</h2>
        </div>

        <div className="header-admin-bar-items ml-auto">
          <input
            type="search"
            className="form-control"
            onInput={cargarBusqueda}
            ref={busqueda}
            placeholder="Búsqueda"
          />
        </div>
      </div>

      <div className="table-container">
        {tiposPeriodos?.length > 0 ? (
          <OrderTable
            {...{ columns }}
            data={tiposPeriodos}
            clase="table-adm"
            actions={[
              {
                icon: "",
                clase: "text-primary",
                style:{display:"contents"},
                event: (item) => showModalEdit(item),
              },
              {
                icon: "",
                clase: "delete",
                style:{display:"contents"},
                event: (item) => showRemoveModalEdit(item),
              },
            ]}
           
          />
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <label>Tipo de periodo</label>
            <Required />
            <input
              className="form-control"
              name="periodoTipoNombre"
              {...register("periodoTipoNombre", {
                required: "Campo requerido",
              })}
            />
            {errors.periodoTipoNombre && (
              <p className="error">{errors.periodoTipoNombre.message}</p>
            )}
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title="Eliminar plantillla"
        message="¿Seguro que desea eliminar el siguiente registro?"
        item={itemSelected.periodoTipoNombre}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              Confirmar
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              Cancelar
            </button>
          </>
        }
      />
    </div>
  );
}

export default TiposPeriodos;
